module.exports = __webpack_public_path__ + "static/patterns-fruit.825fce9c.svg";